export default "__VITE_ASSET__CY8WmW7i__"